// extracted by mini-css-extract-plugin
export default {"loaderContainer":"SparaLoader_loaderContainer__hKyw1","loader":"SparaLoader_loader__Ad3Xf","pulse":"SparaLoader_pulse__doJDJ","text":"SparaLoader_text__AYiBW"};